import script from "./PdfViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfViewer.vue?vue&type=script&setup=true&lang=js"

import "./PdfViewer.vue?vue&type=style&index=0&id=6a2f70b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a2f70b5"]])

export default __exports__